class FillSubCaseController {
  /* @ngInject */
  constructor(
    $state, $stateParams, $window, $http, Session, urls, moment
  ) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.$http = $http;
    this.Session = Session;
    this.moment = moment;
    this.urls = urls;
  }

  $onInit() {
    this.success = false;
    this.subCaseId = this.$stateParams.id;
    this.caseId = this.$stateParams.caseId;
    this.readOnly = this.$stateParams.readOnly === 'true';
    this.ignoreAuth = this.$state.current.name === 'public.case.fillSubCase';
    this.closedSubCase = !this.readOnly
      && this.subCase.CurrentSubCaseState
      && this.subCase.CurrentSubCaseState.state === 'Closed';

    this.response = (
        this.subCase.SubCaseResponse && this.subCase.SubCaseResponse.response
        && Object.keys(this.subCase.SubCaseResponse.response).length
        && this.subCase.SubCaseResponse.response
      )
      || (this.subCase.SubCaseTemplate && this.subCase.SubCaseTemplate.config)
      || {};
  }

  isEmptyResponse() {
    return !Object.keys(this.response).length;
  }

  sendResponse() {
    if (this.isEmptyResponse()) {
      this.errMsg = 'Something went wrong. Please try refreshing the page.';
      this.success = false;
      return;
    }

    const url = `${this.ignoreAuth ? '/public' : ''}/subCase/${this.subCaseId}/response`;

    this.$http.post(url,
      {
        caseId: this.caseId,
        response: this.response,
      },
      { ignoreAuthModule: this.ignoreAuth }
    ).then(() => {
      this.success = true;
    })
    .catch(() => {
      this.errMsg = 'Something went wrong. Please try again.';
      this.success = false;
    });
  }

  download(file) {
    const response = this.subCase.SubCaseResponse;

    if (file.id && response) {
      const url = this.ignoreAuth
        ? `${this.urls.API_SERVER}/api/public/subCase/${this.subCaseId}/response/${
          response.id}/attachment/${file.id}`
        : `${this.urls.API_SERVER}/api/subCase/${this.subCaseId}/response/${
          response.id}/attachment/${file.id}?access_token=${
            this.Session.accessToken}`;

      this.$window.open(url, '_blank');
    }
  }
}

export default FillSubCaseController;



// WEBPACK FOOTER //
// ./client/app/cases/fillSubCase/fillSubCase.controller.js